module.exports = __webpack_public_path__ + "img/icon-selected-theme.d656e82d.svg";